const COMPLETED_CUSTOMER_INFORMATION_MODES = new Set([
  "confirmation_queued",
  "confirmation_skipped",
])

export const customerInformationModeIsCompleted = (mode: unknown) =>
  COMPLETED_CUSTOMER_INFORMATION_MODES.has(
    String(mode ?? "")
      .trim()
      .toLowerCase(),
  )

export const scheduleEventHasCompletedCustomerInformation = (event: ScheduleEvent) =>
  customerInformationModeIsCompleted(
    (event as ScheduleEvent & { customer_information_mode?: string | null })
      .customer_information_mode,
  )

export const contactOrderPlanningRowIsCompleted = (row: {
  event: ScheduleEvent
  customerInformationMode?: unknown
}) =>
  Boolean(row.event.contact_order_id) ||
  customerInformationModeIsCompleted(row.customerInformationMode)
